import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CachedIcon from '@mui/icons-material/Cached';
import Tooltip from "@mui/material/Tooltip";
import {message, Popconfirm} from "antd";
import { isMobile } from 'react-device-detect';
import React, {useState} from "react";
import {AccountRequestDTO} from "../../model/AccountRequestDTO";
import {AccountResponseDTO} from "../../model/ResponsesDTO";
import {ProviderValue, useAxios} from "../../config/axios-config";
import {Customer} from "../../model/Customer";

export const OwnAccountComponent : React.FC<{ customer : Customer }> = (props) => {

    const axiosInstance = useAxios() as ProviderValue
    const controller = new AbortController();
    const signal = controller.signal
    const {customer} = props
    const [messageApi, contextHolder] = message.useMessage();
    const [open, setOpen] = useState<boolean>(false);
    const [openSync, setOpenSync] = useState<boolean>(false);

    const handleConfirm = async () => {
        var request = new AccountRequestDTO(`${customer.firstName} ${customer.lastName}`,
            customer.email, customer.customerid)
        await axiosInstance.post<AccountResponseDTO>(`/accounts/secure/create/parent`, request, {signal}).then((response) => {
            customer.parentGotAccount = true
            openNotification("success", `Operacja powiodła się pomyślnie. ${response.data.optionalDescription != null ? response.data.optionalDescription : ''}`)
        }).catch((e) => {
            let message = e.response?.data?.message
            let defaultMessage = "Spróbuj ponownie w celu resynchronizacji lub skontaktuj się z administratorem"
            console.log(message === undefined ? e : e.response?.data?.message)
            customer.parentGotAccount = false
            openNotification("error", `Operacja nie powiodła się. ${message !== undefined ? message : defaultMessage}`)
        })
        setOpen(false)
        setOpenSync(false)
    }

    const openNotification = (key : string, message : string) => {
        messageApi.open({
            type: key === 'success' ? 'success' : 'error',
            content : `${message}`,
            style: {
                marginRight: '10vh',
            },
            duration: 5,
        });
    };

    if (!customer.parentGotAccount  &&
        customer.customerid !== undefined
        && customer.email !== 'Brak'
        && customer.email !== undefined
        && customer.firstName !== undefined
        && customer.firstName !== '') {
        return (
            <>
                {contextHolder}
                <td>
                    <Popconfirm
                        title="Utwórz/zaktualizuj rodzicowi konto"
                        description="Po potwierdzeniu zostanie rodzicowi wysłany email aktywujący mu jego własne konto do zaznaczania posiłków. Czy jesteś pewien, że chcesz wykonać tę akcję?"
                        open={open}
                        onConfirm={handleConfirm}
                        onCancel={() => setOpen(false)}
                    >
                        <Tooltip title="Rodzic nie ma konta do samodzielnych zgłoszeń posiłków. Możesz je utworzyć"
                                 arrow placement="right">
                            <ErrorRoundedIcon color="warning"
                                              fontSize={isMobile ? "small" : "large"}
                                              onClick={() => setOpen(true)}/>
                        </Tooltip>
                    </Popconfirm>
                </td>
            </>
        )
    } else if (customer.parentGotAccount
        && customer.customerid !== undefined
        && customer.email !== 'Brak'
        && customer.email !== undefined
        && customer.firstName !== undefined
        && customer.firstName !== '') {
        return (
            <>
                {contextHolder}
                <td>
                    <Tooltip title="Rodzic ma konto do samodzielnych zgłoszeń posiłków."
                             arrow placement="right">
                        <CheckCircleRoundedIcon color={`success`} fontSize={isMobile ? "small" : "large"}/>
                    </Tooltip>
                    <Popconfirm
                        title="Zresynchronizuj konto rodzicowi"
                        description="Jeżeli rodzic zgłosił, że ma problemy z zalogowaniem się do konta, możesz dokonać resynchronizacji, która spowoduje próbę jego ponownego ustawienia. Czy jesteś pewien, że chcesz wykonać tę akcję?"
                        open={openSync}
                        onConfirm={handleConfirm}
                        onCancel={() => setOpenSync(false)}
                    >
                        <Tooltip title="Resynchronizuj konto rodzica."
                                 arrow placement="right">
                            <CachedIcon color={`action`} fontSize={"small"} onClick={() => setOpenSync(true)}/>
                        </Tooltip>
                    </Popconfirm>

                </td>
            </>
        )
    }

    return (
        <td>
            <Tooltip title="Rodzic nie może zgłaszać samodzielnie posiłków.
                Nie można założyć konta (brak emaila)."
                     arrow placement="right">
                <CancelRoundedIcon color={`error`} fontSize={isMobile ? "small" : "large"} />
            </Tooltip>
        </td>
    )
}